export default "__VITE_ASSET__DtCMOs6e__"